export default __webpack_public_path__ + "static/media/check.56afcc79.svg";